// extracted by mini-css-extract-plugin
export default {"container":"PrimaryButton_container__-sgZ3","primary":"PrimaryButton_primary__vOtM8"};